import { modifyState } from '~src/state';
import { SpellCheckClient } from '~core/spellcheck';

export default async function initSpellCheckerClient() {
  const spellCheckerApiClient = await SpellCheckClient.createSpellCheckerApiClient(
    process.env.SPELLCHECK_API_URL
  );
  const spellChecker = new SpellCheckClient(spellCheckerApiClient, 'it-IT');
  modifyState('spellChecker', spellChecker);
}
